import { Injectable } from '@angular/core';
import {DayOfWeek} from '../common/constants';
import {CustomSickPayCode, DefaultPaymentType, ProjectSettingDisplayConfig} from '../common/project-setting.model';

export namespace ProjectSettingsConstants {
  @Injectable({
    providedIn: 'root'
  })
  export class ProjectSettings {
    public static get ProducerWorkWeekOptions(): ReadonlyArray<{name: string; value: DayOfWeek}> {
      return [
        { name: 'Monday - Sunday', value: DayOfWeek.Monday },
        { name: 'Tuesday - Monday', value: DayOfWeek.Tuesday },
        { name: 'Wednesday - Tuesday', value: DayOfWeek.Wednesday },
        { name: 'Thursday - Wednesday', value: DayOfWeek.Thursday },
        { name: 'Friday - Thursday', value: DayOfWeek.Friday },
        { name: 'Saturday - Friday', value: DayOfWeek.Saturday },
        { name: 'Sunday - Saturday', value: DayOfWeek.Sunday }
      ];
    }

    public static get PayrollWeekDisplayOptions(): ReadonlyArray<{name: string; value: DayOfWeek}> {
      return [
        { name: 'Monday - Sunday', value: DayOfWeek.Monday },
        { name: 'Sunday - Saturday', value: DayOfWeek.Sunday }
      ];
    }

    public static get SickPayCodeGroupOptions(): ReadonlyArray<{name: string; value: CustomSickPayCode}> {
      return [
        { name: '117, 209 (Default)', value: CustomSickPayCode.Default },
        { name: '123, 151 (Subject to PH+W and V+H)', value: CustomSickPayCode.Sick2 },
        { name: '123, 155 (Subject to PH+W and V+H, OT does not pull from accrual)', value: CustomSickPayCode.Sick3 }
      ];
    }

    public static get DefaultHNWPaymentOptions(): ReadonlyArray<{name: string; value: DefaultPaymentType}> {
      return [
        { name: '', value: DefaultPaymentType.Blank },
        { name: 'No Pay', value: DefaultPaymentType.NoPay },
        { name: 'Guar', value: DefaultPaymentType.Guar },
        { name: 'Min Call', value: DefaultPaymentType.MinCall }
      ];
    }

    public static get DefaultPayTypeOptions(): ReadonlyArray<{name: string; value: DefaultPaymentType}> {
      return [
        { name: '', value: DefaultPaymentType.Blank },
        { name: 'Guar', value: DefaultPaymentType.Guar },
        { name: 'Min Call', value: DefaultPaymentType.MinCall },
        { name: 'No Pay', value: DefaultPaymentType.NoPay },
      ];
    }

    public static get UkProjectSettingDisplayConfig(): ProjectSettingDisplayConfig {
      return {
        tabsToDisplay: {
          projectDetails: true,
          accountCoding: true,
          contracts: true,
          approvalWorkflow: true,
          departments: true,
          glShortcuts: false
        },
        projectDetails: {
          producerWorkWeek: false,
          payrollWeekDisplay: false,
          cumulativeBrekage: false,
          holidayPayCodeGroup: false,
          defaultHolNWpayments: false,
          defaultForHoldVacationBereavementJuryDuty: false,
          sickPayCodeGroup: false,
          mobileUpdate: true,
          excessiveMPRulesApply: false,
          paymasterinfo: false,
          compensatoryRest: true,
          proRatedAllowance: true
        }
      };
    }

    public static get USProjectSettingDisplayConfig(): ProjectSettingDisplayConfig {
      return {
        tabsToDisplay: {
          projectDetails: true,
          accountCoding: true,
          departments: true,
          contracts: true,
          approvalWorkflow: true,
          glShortcuts: true
        },
        projectDetails: {
          producerWorkWeek: true,
          payrollWeekDisplay: true,
          cumulativeBrekage: true,
          holidayPayCodeGroup: true,
          defaultHolNWpayments: true,
          defaultForHoldVacationBereavementJuryDuty: true,
          sickPayCodeGroup: true,
          mobileUpdate: true,
          excessiveMPRulesApply: true,
          paymasterinfo: true,
          compensatoryRest: false,
          proRatedAllowance: false
        }
      };
    }

  }
}
